import React from 'react';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import LayoutServicePage from 'components/mui/Layouts/LayoutServicePage';
import { grey } from '@mui/material/colors';

import notFoundImg from 'pages/servicePage/images/notFound.png';

const NotFoundContainer = ({ link, title, description, buttonText }) => {
  const { formatMessage } = useIntl();

  return (
    <LayoutServicePage>
      <Stack alignItems="center" justifyContent="center" spacing={1}>
        <img src={notFoundImg} alt="not-found" />
        <Typography variant="h5">{formatMessage(title)}</Typography>
        <Typography variant="body1" color={grey[600]} maxWidth={600} textAlign="center">
          {formatMessage(description)}
        </Typography>
        <Button component={Link} to={link} sx={{ mt: '32px !important' }}>
          {formatMessage(buttonText)}
        </Button>
      </Stack>
    </LayoutServicePage>
  );
};

export default NotFoundContainer;
